import { action, observable } from 'mobx';
import _ from 'lodash';
import { RegisterForm } from 'application/membership/forms';
import {RegisterService} from 'application/membership/services';
import { BaseViewStore } from 'core/stores';

class RegisterViewStore extends BaseViewStore {
    @observable accessor errorMessage = null;
    @observable accessor loadingActivation = true;
    routes = {
        login: this.navigateToLoginPage,
        dashboard: this.navigateToDashboard
    };

    registerForm = new RegisterForm({
        onSuccess: async (form) => {
            const { email, password, confirmPassword, firstName, lastName, botProtection } = form.values();
            await this.register({
                email,
                password,
                confirmPassword,
                firstName,
                lastName,
                botProtection
            });
        },
        onError: () => {
        }
    });

    constructor(rootStore) {
        super();

        this.rootStore = rootStore;
        this.registerService = new RegisterService(rootStore.application.baasic.apiClient);
    }

    @action.bound
    navigateToLoginPage() {
        this.rootStore.routerStore.goTo('master.app.membership.login');
    }

    @action.bound
    navigateToDashboard() {
        this.rootStore.routerStore.goTo(this.rootStore.initialState);
    }

    @action.bound
    handleActivation() {
        this.loadingActivation = false;
    }

    @action.bound
    async register({ email, password, confirmPassword, firstName, lastName, botProtection }) {
        this.loaderStore.suspend();
        try {
            const challengeResponse = botProtection;
            const username = _.head(email.split('@')) + '_' + Date.now() + Math.random();
            await this.registerService.create({ firstName, lastName, username, email, password, confirmPassword, challengeResponse });
            this.rootStore.routerStore.goTo('master.app.membership.registration-success');
        } catch ({ statusCode, data }) {

            //TODO implement translation if needed
            switch (statusCode) {
                case 400:
                    this.registerForm.invalidate('Requested action could not be understood by the system.');
                    break;
                case 401:
                    this.registerForm.invalidate('Requested action requires authentication.');
                    break;
                case 403:
                    this.registerForm.invalidate('System refuses to fulfill the requested action.');
                    break;
                case 409:
                    this.registerForm.invalidate('Requested action could not be carried out because of a conflict in the system.');
                    break;
                case 500:
                    this.registerForm.invalidate('A generic error has occurred on the system.');
            }
        }
        this.loaderStore.resume();
    }
}

export default RegisterViewStore;